export default "__VITE_ASSET__$6DhiM4A__"